import { inject, type InjectionKey, type Ref } from 'vue'

export type TabsVariant = 'segmented' | 'underline'

export interface TabsContext {
  current: Ref<string>
  variant: Ref<TabsVariant>
  base: string
  select: (value: string) => void
}

export const TABS: InjectionKey<TabsContext> = Symbol('ui-tabs')

export function useTabs(part: string): TabsContext {
  const context = inject(TABS, null)
  if (!context) throw new Error(`${part} must be used inside <Tabs>`)
  return context
}

export const tabId = (base: string, value: string) => `${base}-tab-${value}`
export const panelId = (base: string, value: string) => `${base}-panel-${value}`
